export default __webpack_public_path__ + "ad75c6d5ffe5b90aadb10caf90983bb0.png";